import BackToTop from "@/components/base/BackToTop";
import Footer from "@/components/feature/Footer";
import Navbar from "@/components/feature/Navbar";
import useSeo from "@/hooks/useSeo";
import { articles } from "@/mocks/articles";
import { faqs } from "@/mocks/faqs";
import CategorySection from "./components/CategorySection";
import FaqSection from "./components/FaqSection";
import FeaturedSection from "./components/FeaturedSection";
import HeroSection from "./components/HeroSection";
import LatestSection from "./components/LatestSection";
import RankingSection from "./components/RankingSection";
import SubscribeSection from "./components/SubscribeSection";
import TimelineSection from "./components/TimelineSection";

const BASE = "https://iosfxw.cn";

export default function Home() {
  useSeo({
    title: "黑料五一｜假期事件盘点·热点舆情观察 - 瓜田速报",
    description:
      "黑料五一假期事件盘点专题，集中整理劳动节前后各类热点事件与争议话题，按时间顺序梳理黑料五一期间大事件，涵盖娱乐动态、品牌营销、出行消费与社交热点，帮你一次看全五一假期爆料汇总。",
    keywords: "黑料五一,黑料五一事件盘点,黑料五一期间大事件,五一假期爆料汇总,五一热点盘点",
    canonical: `${BASE}/`,
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "瓜田速报",
        url: BASE,
        email: "contact@guatian-report.com",
        description:
          "专注于假期热点复盘的中文内容站，围绕五一假期整理被广泛讨论的事件、争议与行业动态。",
      },
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: "瓜田速报",
        url: BASE,
        inLanguage: "zh-CN",
        potentialAction: {
          "@type": "SearchAction",
          target: `${BASE}/topics?q={search_term_string}`,
          "query-input": "required name=search_term_string",
        },
      },
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqs.map((faq) => ({
          "@type": "Question",
          name: faq.question,
          acceptedAnswer: { "@type": "Answer", text: faq.answer },
        })),
      },
      {
        "@context": "https://schema.org",
        "@type": "ItemList",
        name: "五一假期事件盘点文章列表",
        itemListElement: articles.map((article, index) => ({
          "@type": "ListItem",
          position: index + 1,
          url: `${BASE}/topics/${article.slug}`,
          name: article.title,
        })),
      },
    ],
  });

  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <FeaturedSection />
        <TimelineSection />
        <RankingSection />
        <LatestSection />
        <FaqSection />
        <SubscribeSection />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}